<template>
  <k-editor-form v-if="setting">
    <template v-slot:left>
      <k-text-field :value="id" label="ID" readonly></k-text-field>
      <k-text-field v-model="setting.name" label="Name" :readonly="id != null " persistent-hint hint="Name cannot be edited after creation."></k-text-field>
      <k-text-field v-model="setting.title" label="Title"></k-text-field>
      <k-autocomplete
        :items="settingTypes"
        v-model="setting.type"
        label="Type"
        item-text="label"
        item-value="value">
      </k-autocomplete>

      <k-autocomplete
        :items="notifiers"
        v-model="setting.value.module"
        label="Module"
        item-text="name"
        item-value="value"
        v-if="setting.type == 'external_notifier'">
      </k-autocomplete>
    </template>
    
    <template v-slot:right>
      <template v-if="setting.type == 'external_notifier' && setting.value">
        <div class="mt-1">Form</div>
        <form-editor v-model="setting.value.form" :height="230"></form-editor>
        <template v-if="setting.value.module == 'EPG'">

          <div class="mt-1" >
            Template 
            <span @click="show_template_tooltip = !show_template_tooltip" style="cursor: pointer;">(help)</span>
          </div>
          <div v-if="show_template_tooltip" class="elevation-1">
            <div>
              <h4>Help</h4>
              Format time (<a href="https://man7.org/linux/man-pages/man3/strftime.3.html" target="_blank">strftime manual</a>):<br>
              <code>{{ '\{\{#format_time\}\}\{"format": "[strftime format]", "timestamp": \{\{timestamp\}\}\}\{\{/format_time\}\}' }}</code><br>
              Loop events:<br>
              <code>{{ '\{\{#events\}\}\{\{/events\}\}'}}</code>
            </div>
          </div>
          <CodeEditor v-model="setting.value.template" lang="xml" height="220px" />
        </template>
      </template>
      <template v-else>
        <json-editor v-model="setting.value" v-if="setting.value"></json-editor>
      </template>
    </template>
    <template v-slot:right-buttons>
      <k-btn size="m" flat @click="reset">Reset</k-btn>
      <k-btn size="m" color="success" @click="save(false)">Save</k-btn>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
import CodeEditor from '@/components/CodeEditor';
import FormEditor from '@/components/FormEditor';
import SettingsModel from '@/models/settings.js'
import ExternalModel from '@/models/external.js'

export default {
  props: ['id'],
  components: {
    JsonEditor,
    CodeEditor,
    FormEditor
  },
  data() {
    var ch = this.$cloudserver.channel("settings:"+(this.id||"create"));
    return {
      ws_channel: ch,
      setting: this.convertSetting(ch.data),
      settingTypes: SettingsModel.types(),
      show_template_tooltip: false
    };
  },
  watch: {
    'ws_channel.data': {
      handler(newVal, oldVal) {
        this.setting = this.convertSetting(newVal, oldVal);
      },
      deep: true
    },
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("settings:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    notifiers() {
      return ExternalModel.notifiers;
    }
  },
  methods: {
    convertSetting (newVal, oldVal) {
      var setting = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(setting) == "undefined" || _.isEmpty(setting)) return undefined;
      return setting;
    },
    reset() {
      this.setting = this.convertSetting(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var setting = _.cloneDeep(this.setting);
        this.ws_channel.save({setting: setting})
          .then((msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("Setting was created!");
            } else {
              self.$message.success("Setting was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create setting!");
            } else {
              self.$message.warning("Unable to update setting!");
            }
          });
      }
    }
  }
}
</script>
